module.exports = __webpack_public_path__ + "img/shanxi_fuzhuanggongcheng.05b47e80.jpeg";